
import apiClient from './api';

export const getDomainValidators = async (domainId) => {
  const response = await apiClient.get('/api/Validations/validators', {
    params: { DomainId: domainId } // Notez le paramètre avec majuscule
  });
  
  // Retourner directement les items si la réponse est paginée
  return response.data?.items || response.data;
};

export const createDomainValidator = async (validatorData) => {
  const response = await apiClient.post('/api/validations/validators', validatorData);
  return response.data;
};

export const deleteDomainValidator = async ({ domainId, accountId }) => {
  const response = await apiClient.delete(`/api/validations/validators/${domainId}/${accountId}`);
  return response.data;
};

export const getValidationRules = async (domainId) => {
  const response = await apiClient.get('/api/validations/rules', {
    params: { domainId }
  });
  return response.data;
};

export const getValidationRule = async (domainId, entityName) => {
  const response = await apiClient.get(`/api/validations/rules/${domainId}/${entityName}`);
  return response.data;
};

export const createOrUpdateValidationRule = async (ruleData) => {
  const response = await apiClient.post('/api/validations/rules', ruleData);
  return response.data;
};